module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 0);
}([function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = a(r(1)),
      o = a(r(4));

  function a(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  r(7);

  var i = function i(e, t) {
    var r = e.label;
    return e.insertAfter ? t + r : r + t;
  },
      m = function m(e) {
    var t = e.format,
        r = e.height,
        o = e.min,
        a = e.max,
        m = e.size,
        l = e.steps,
        u = e.theme,
        s = e.value,
        c = function (e, t, r, n) {
      for (var o = [], a = 0; a <= n; a++) {
        var m = {
          percent: Math.abs((r / n * a).toFixed(2)) / r * 100,
          label: i(e, Math.abs(((r - t) / n * a).toFixed(2)) + t)
        };
        o.push(m);
      }

      return o;
    }(t, o, a, l),
        f = s / a * 100,
        h = i(t, s),
        p = c.map(function (e, t) {
      var r = e.label,
          o = e.percent;
      return n.default.createElement("li", {
        key: t,
        style: {
          bottom: "calc(" + o + "% - 1px)"
        }
      }, r);
    }),
        d = {
      height: r + "px"
    },
        _ = {
      height: f + "%"
    },
        b = {
      height: "calc(" + r + "px - 57px)"
    };

    return n.default.createElement("div", {
      style: d,
      className: "thermometer thermometer--" + m + " thermometer--theme-" + u
    }, n.default.createElement("div", {
      className: "thermometer__draw-a"
    }), n.default.createElement("div", {
      className: "thermometer__draw-b"
    }), n.default.createElement("div", {
      className: "thermometer__meter"
    }, n.default.createElement("ul", {
      className: "thermometer__statistics"
    }, p), n.default.createElement("div", {
      style: _,
      className: "thermometer__mercury"
    }, n.default.createElement("div", {
      className: "thermometer__percent-current"
    }, h), n.default.createElement("div", {
      className: "thermometer__mask"
    }, n.default.createElement("div", {
      className: "thermometer__bg-color",
      style: b
    })))));
  };

  m.propTypes = {
    format: o.default.shape({
      label: o.default.string,
      insertAfter: o.default.bool
    }),
    height: o.default.number,
    max: o.default.number,
    size: o.default.oneOf(["small", "normal", "large"]),
    steps: o.default.number,
    theme: o.default.oneOf(["light", "dark"]),
    value: o.default.number
  }, m.defaultProps = {
    format: {
      label: "%",
      insertAfter: !0
    },
    height: 200,
    max: 100,
    size: "small",
    steps: 4,
    theme: "light",
    value: 0
  }, t.default = m;
}, function (e, t, r) {
  "use strict";

  e.exports = r(2);
}, function (e, t, r) {
  "use strict";
  /** @license React v16.8.6
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var n = r(3),
      o = "function" == typeof Symbol && Symbol.for,
      a = o ? Symbol.for("react.element") : 60103,
      i = o ? Symbol.for("react.portal") : 60106,
      m = o ? Symbol.for("react.fragment") : 60107,
      l = o ? Symbol.for("react.strict_mode") : 60108,
      u = o ? Symbol.for("react.profiler") : 60114,
      s = o ? Symbol.for("react.provider") : 60109,
      c = o ? Symbol.for("react.context") : 60110,
      f = o ? Symbol.for("react.concurrent_mode") : 60111,
      h = o ? Symbol.for("react.forward_ref") : 60112,
      p = o ? Symbol.for("react.suspense") : 60113,
      d = o ? Symbol.for("react.memo") : 60115,
      _ = o ? Symbol.for("react.lazy") : 60116,
      b = "function" == typeof Symbol && Symbol.iterator;

  function g(e) {
    for (var t = arguments.length - 1, r = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 0; n < t; n++) {
      r += "&args[]=" + encodeURIComponent(arguments[n + 1]);
    }

    !function (e, t, r, n, o, a, i, m) {
      if (!e) {
        if (e = void 0, void 0 === t) e = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var l = [r, n, o, a, i, m],
              u = 0;
          (e = Error(t.replace(/%s/g, function () {
            return l[u++];
          }))).name = "Invariant Violation";
        }
        throw e.framesToPop = 1, e;
      }
    }(!1, "Minified React error #" + e + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", r);
  }

  var y = {
    isMounted: function isMounted() {
      return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
  },
      v = {};

  function x(e, t, r) {
    this.props = e, this.context = t, this.refs = v, this.updater = r || y;
  }

  function w() {}

  function k(e, t, r) {
    this.props = e, this.context = t, this.refs = v, this.updater = r || y;
  }

  x.prototype.isReactComponent = {}, x.prototype.setState = function (e, t) {
    "object" != typeof e && "function" != typeof e && null != e && g("85"), this.updater.enqueueSetState(this, e, t, "setState");
  }, x.prototype.forceUpdate = function (e) {
    this.updater.enqueueForceUpdate(this, e, "forceUpdate");
  }, w.prototype = x.prototype;
  var O = k.prototype = new w();
  O.constructor = k, n(O, x.prototype), O.isPureReactComponent = !0;
  var S = {
    current: null
  },
      j = {
    current: null
  },
      E = Object.prototype.hasOwnProperty,
      R = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function C(e, t, r) {
    var n = void 0,
        o = {},
        i = null,
        m = null;
    if (null != t) for (n in void 0 !== t.ref && (m = t.ref), void 0 !== t.key && (i = "" + t.key), t) {
      E.call(t, n) && !R.hasOwnProperty(n) && (o[n] = t[n]);
    }
    var l = arguments.length - 2;
    if (1 === l) o.children = r;else if (1 < l) {
      for (var u = Array(l), s = 0; s < l; s++) {
        u[s] = arguments[s + 2];
      }

      o.children = u;
    }
    if (e && e.defaultProps) for (n in l = e.defaultProps) {
      void 0 === o[n] && (o[n] = l[n]);
    }
    return {
      $$typeof: a,
      type: e,
      key: i,
      ref: m,
      props: o,
      _owner: j.current
    };
  }

  function P(e) {
    return "object" == typeof e && null !== e && e.$$typeof === a;
  }

  var U = /\/+/g,
      T = [];

  function $(e, t, r, n) {
    if (T.length) {
      var o = T.pop();
      return o.result = e, o.keyPrefix = t, o.func = r, o.context = n, o.count = 0, o;
    }

    return {
      result: e,
      keyPrefix: t,
      func: r,
      context: n,
      count: 0
    };
  }

  function A(e) {
    e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > T.length && T.push(e);
  }

  function M(e, t, r) {
    return null == e ? 0 : function e(t, r, n, o) {
      var m = typeof t;
      "undefined" !== m && "boolean" !== m || (t = null);
      var l = !1;
      if (null === t) l = !0;else switch (m) {
        case "string":
        case "number":
          l = !0;
          break;

        case "object":
          switch (t.$$typeof) {
            case a:
            case i:
              l = !0;
          }

      }
      if (l) return n(o, t, "" === r ? "." + L(t, 0) : r), 1;
      if (l = 0, r = "" === r ? "." : r + ":", Array.isArray(t)) for (var u = 0; u < t.length; u++) {
        var s = r + L(m = t[u], u);
        l += e(m, s, n, o);
      } else if (s = null === t || "object" != typeof t ? null : "function" == typeof (s = b && t[b] || t["@@iterator"]) ? s : null, "function" == typeof s) for (t = s.call(t), u = 0; !(m = t.next()).done;) {
        l += e(m = m.value, s = r + L(m, u++), n, o);
      } else "object" === m && g("31", "[object Object]" == (n = "" + t) ? "object with keys {" + Object.keys(t).join(", ") + "}" : n, "");
      return l;
    }(e, "", t, r);
  }

  function L(e, t) {
    return "object" == typeof e && null !== e && null != e.key ? function (e) {
      var t = {
        "=": "=0",
        ":": "=2"
      };
      return "$" + ("" + e).replace(/[=:]/g, function (e) {
        return t[e];
      });
    }(e.key) : t.toString(36);
  }

  function N(e, t) {
    e.func.call(e.context, t, e.count++);
  }

  function I(e, t, r) {
    var n = e.result,
        o = e.keyPrefix;
    e = e.func.call(e.context, t, e.count++), Array.isArray(e) ? B(e, n, r, function (e) {
      return e;
    }) : null != e && (P(e) && (e = function (e, t) {
      return {
        $$typeof: a,
        type: e.type,
        key: t,
        ref: e.ref,
        props: e.props,
        _owner: e._owner
      };
    }(e, o + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(U, "$&/") + "/") + r)), n.push(e));
  }

  function B(e, t, r, n, o) {
    var a = "";
    null != r && (a = ("" + r).replace(U, "$&/") + "/"), M(e, I, t = $(t, a, n, o)), A(t);
  }

  function q() {
    var e = S.current;
    return null === e && g("321"), e;
  }

  var z = {
    Children: {
      map: function map(e, t, r) {
        if (null == e) return e;
        var n = [];
        return B(e, n, null, t, r), n;
      },
      forEach: function forEach(e, t, r) {
        if (null == e) return e;
        M(e, N, t = $(null, null, t, r)), A(t);
      },
      count: function count(e) {
        return M(e, function () {
          return null;
        }, null);
      },
      toArray: function toArray(e) {
        var t = [];
        return B(e, t, null, function (e) {
          return e;
        }), t;
      },
      only: function only(e) {
        return P(e) || g("143"), e;
      }
    },
    createRef: function createRef() {
      return {
        current: null
      };
    },
    Component: x,
    PureComponent: k,
    createContext: function createContext(e, t) {
      return void 0 === t && (t = null), (e = {
        $$typeof: c,
        _calculateChangedBits: t,
        _currentValue: e,
        _currentValue2: e,
        _threadCount: 0,
        Provider: null,
        Consumer: null
      }).Provider = {
        $$typeof: s,
        _context: e
      }, e.Consumer = e;
    },
    forwardRef: function forwardRef(e) {
      return {
        $$typeof: h,
        render: e
      };
    },
    lazy: function lazy(e) {
      return {
        $$typeof: _,
        _ctor: e,
        _status: -1,
        _result: null
      };
    },
    memo: function memo(e, t) {
      return {
        $$typeof: d,
        type: e,
        compare: void 0 === t ? null : t
      };
    },
    useCallback: function useCallback(e, t) {
      return q().useCallback(e, t);
    },
    useContext: function useContext(e, t) {
      return q().useContext(e, t);
    },
    useEffect: function useEffect(e, t) {
      return q().useEffect(e, t);
    },
    useImperativeHandle: function useImperativeHandle(e, t, r) {
      return q().useImperativeHandle(e, t, r);
    },
    useDebugValue: function useDebugValue() {},
    useLayoutEffect: function useLayoutEffect(e, t) {
      return q().useLayoutEffect(e, t);
    },
    useMemo: function useMemo(e, t) {
      return q().useMemo(e, t);
    },
    useReducer: function useReducer(e, t, r) {
      return q().useReducer(e, t, r);
    },
    useRef: function useRef(e) {
      return q().useRef(e);
    },
    useState: function useState(e) {
      return q().useState(e);
    },
    Fragment: m,
    StrictMode: l,
    Suspense: p,
    createElement: C,
    cloneElement: function cloneElement(e, t, r) {
      null == e && g("267", e);
      var o = void 0,
          i = n({}, e.props),
          m = e.key,
          l = e.ref,
          u = e._owner;

      if (null != t) {
        void 0 !== t.ref && (l = t.ref, u = j.current), void 0 !== t.key && (m = "" + t.key);
        var s = void 0;

        for (o in e.type && e.type.defaultProps && (s = e.type.defaultProps), t) {
          E.call(t, o) && !R.hasOwnProperty(o) && (i[o] = void 0 === t[o] && void 0 !== s ? s[o] : t[o]);
        }
      }

      if (1 === (o = arguments.length - 2)) i.children = r;else if (1 < o) {
        s = Array(o);

        for (var c = 0; c < o; c++) {
          s[c] = arguments[c + 2];
        }

        i.children = s;
      }
      return {
        $$typeof: a,
        type: e.type,
        key: m,
        ref: l,
        props: i,
        _owner: u
      };
    },
    createFactory: function createFactory(e) {
      var t = C.bind(null, e);
      return t.type = e, t;
    },
    isValidElement: P,
    version: "16.8.6",
    unstable_ConcurrentMode: f,
    unstable_Profiler: u,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
      ReactCurrentDispatcher: S,
      ReactCurrentOwner: j,
      assign: n
    }
  },
      F = {
    default: z
  },
      D = F && z || F;
  e.exports = D.default || D;
}, function (e, t, r) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  var n = Object.getOwnPropertySymbols,
      o = Object.prototype.hasOwnProperty,
      a = Object.prototype.propertyIsEnumerable;

  function i(e) {
    if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }

  e.exports = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

      for (var t = {}, r = 0; r < 10; r++) {
        t["_" + String.fromCharCode(r)] = r;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var n = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        n[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var r, m, l = i(e), u = 1; u < arguments.length; u++) {
      for (var s in r = Object(arguments[u])) {
        o.call(r, s) && (l[s] = r[s]);
      }

      if (n) {
        m = n(r);

        for (var c = 0; c < m.length; c++) {
          a.call(r, m[c]) && (l[m[c]] = r[m[c]]);
        }
      }
    }

    return l;
  };
}, function (e, t, r) {
  e.exports = r(5)();
}, function (e, t, r) {
  "use strict";

  var n = r(6);

  function o() {}

  function a() {}

  a.resetWarningCache = o, e.exports = function () {
    function e(e, t, r, o, a, i) {
      if (i !== n) {
        var m = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw m.name = "Invariant Violation", m;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var r = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: a,
      resetWarningCache: o
    };
    return r.PropTypes = r, r;
  };
}, function (e, t, r) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, r) {
  var n = r(8);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  r(10)(n, o);
  n.locals && (e.exports = n.locals);
}, function (e, t, r) {
  (e.exports = r(9)(!1)).push([e.i, '.transition-a, .thermometer .thermometer__mercury {\n  transition: all .5s ease-in-out; }\n\n.extend-a, .thermometer .thermometer__percent-current:before, .thermometer .thermometer__percent-current:after, .thermometer .thermometer__draw-b:after, .thermometer .thermometer__draw-b:before {\n  content: "";\n  margin: auto; }\n\n.font-style-a, .thermometer ul.thermometer__statistics {\n  font-size: 11px;\n  font-style: italic;\n  font-weight: 500; }\n\n.font-style-b, .thermometer .thermometer__percent-current {\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500; }\n\n.no-gap, .thermometer ul.thermometer__statistics {\n  margin: 0;\n  padding: 0; }\n\n.thermometer-small ul.thermometer__statistics li, .thermometer--small ul.thermometer__statistics li {\n  width: 52px;\n  padding-left: 8px; }\n\n.thermometer-small .thermometer__draw-a, .thermometer--small .thermometer__draw-a {\n  width: 14px; }\n  .thermometer-small .thermometer__draw-a:after, .thermometer--small .thermometer__draw-a:after {\n    position: absolute;\n    top: initial;\n    right: initial;\n    bottom: -12px;\n    left: -10px;\n    width: 34px;\n    height: 34px; }\n\n.thermometer-small .thermometer__draw-b:before, .thermometer--small .thermometer__draw-b:before {\n  width: 4px; }\n\n.thermometer-small .thermometer__draw-b:after, .thermometer--small .thermometer__draw-b:after {\n  position: absolute;\n  top: 13px;\n  right: 0;\n  bottom: initial;\n  left: 0;\n  width: 24px;\n  height: 24px; }\n\n.thermometer-small .thermometer__meter, .thermometer--small .thermometer__meter {\n  width: 4px; }\n\n.thermometer-normal ul.thermometer__statistics li, .thermometer--normal ul.thermometer__statistics li {\n  width: 42px;\n  padding-left: 13px; }\n\n.thermometer-normal .thermometer__draw-a, .thermometer--normal .thermometer__draw-a {\n  width: 30px; }\n  .thermometer-normal .thermometer__draw-a:after, .thermometer--normal .thermometer__draw-a:after {\n    position: absolute;\n    top: initial;\n    right: initial;\n    bottom: -20px;\n    left: -10px;\n    width: 50px;\n    height: 50px; }\n\n.thermometer-normal .thermometer__draw-b:before, .thermometer--normal .thermometer__draw-b:before {\n  width: 10px; }\n\n.thermometer-normal .thermometer__draw-b:after, .thermometer--normal .thermometer__draw-b:after {\n  position: absolute;\n  top: 8px;\n  right: 0;\n  bottom: initial;\n  left: 0;\n  width: 34px;\n  height: 34px; }\n\n.thermometer-normal .thermometer__meter, .thermometer--normal .thermometer__meter {\n  width: 10px; }\n\n.thermometer-large ul.thermometer__statistics li, .thermometer--large ul.thermometer__statistics li {\n  width: 52px;\n  padding-left: 34px; }\n\n.thermometer-large .thermometer__draw-a, .thermometer--large .thermometer__draw-a {\n  width: 50px; }\n  .thermometer-large .thermometer__draw-a:after, .thermometer--large .thermometer__draw-a:after {\n    position: absolute;\n    top: initial;\n    right: initial;\n    bottom: -30px;\n    left: -10px;\n    width: 70px;\n    height: 70px; }\n\n.thermometer-large .thermometer__draw-b:before, .thermometer--large .thermometer__draw-b:before {\n  width: 30px; }\n\n.thermometer-large .thermometer__draw-b:after, .thermometer--large .thermometer__draw-b:after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: initial;\n  left: 0;\n  width: 50px;\n  height: 50px; }\n\n.thermometer-large .thermometer__meter, .thermometer--large .thermometer__meter {\n  width: 30px; }\n\n.thermometer-light .thermometer__draw-a, .thermometer--theme-light .thermometer__draw-a, .thermometer-light .thermometer__draw-a:before, .thermometer--theme-light .thermometer__draw-a:before, .thermometer-light .thermometer__draw-a:after, .thermometer--theme-light .thermometer__draw-a:after {\n  background-color: #fff; }\n\n.thermometer-light .thermometer__meter, .thermometer--theme-light .thermometer__meter {\n  background-color: #d6d6d6; }\n\n.thermometer-light ul.thermometer__statistics li, .thermometer--theme-light ul.thermometer__statistics li {\n  color: #000; }\n  .thermometer-light ul.thermometer__statistics li:before, .thermometer--theme-light ul.thermometer__statistics li:before {\n    background: linear-gradient(90deg, rgba(0, 0, 0, 0.2), transparent); }\n\n.thermometer-light .thermometer__percent-current, .thermometer--theme-light .thermometer__percent-current {\n  color: #000;\n  background-color: #fff; }\n  .thermometer-light .thermometer__percent-current:after, .thermometer--theme-light .thermometer__percent-current:after {\n    border-left: 8px solid #fff; }\n\n.thermometer-dark .thermometer__draw-a, .thermometer--theme-dark .thermometer__draw-a, .thermometer-dark .thermometer__draw-a:before, .thermometer--theme-dark .thermometer__draw-a:before, .thermometer-dark .thermometer__draw-a:after, .thermometer--theme-dark .thermometer__draw-a:after {\n  background-color: #333; }\n\n.thermometer-dark .thermometer__meter, .thermometer--theme-dark .thermometer__meter {\n  background-color: #1d1d1d; }\n\n.thermometer-dark ul.thermometer__statistics li, .thermometer--theme-dark ul.thermometer__statistics li {\n  color: #fff; }\n  .thermometer-dark ul.thermometer__statistics li:before, .thermometer--theme-dark ul.thermometer__statistics li:before {\n    background: linear-gradient(90deg, rgba(255, 255, 255, 0.2), transparent); }\n\n.thermometer-dark .thermometer__percent-current, .thermometer--theme-dark .thermometer__percent-current {\n  color: #fff;\n  background-color: #1d1d1d; }\n  .thermometer-dark .thermometer__percent-current:after, .thermometer--theme-dark .thermometer__percent-current:after {\n    border-left: 8px solid #1d1d1d; }\n\n.thermometer {\n  width: 100px;\n  position: relative; }\n  .thermometer ul.thermometer__statistics {\n    position: absolute;\n    top: 0;\n    right: initial;\n    bottom: initial;\n    left: 0;\n    height: 100%;\n    z-index: 1; }\n    .thermometer ul.thermometer__statistics li {\n      position: absolute;\n      top: initial;\n      right: initial;\n      bottom: initial;\n      left: 0;\n      list-style: none; }\n      .thermometer ul.thermometer__statistics li:before {\n        position: absolute;\n        top: initial;\n        right: initial;\n        bottom: -1px;\n        left: 0;\n        content: "";\n        width: 100%;\n        height: 1px; }\n  .thermometer .thermometer__meter {\n    position: absolute;\n    top: 12px;\n    right: 0;\n    bottom: initial;\n    left: 0;\n    height: calc(100% - 58px);\n    margin: auto;\n    border-radius: 50px 50px 0 0;\n    z-index: 1; }\n  .thermometer .thermometer__mercury {\n    position: absolute;\n    top: initial;\n    right: initial;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 0;\n    border-radius: 50px 50px 0 0; }\n  .thermometer .thermometer__mask {\n    position: absolute;\n    top: initial;\n    right: initial;\n    bottom: -1px;\n    left: initial;\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n    border-radius: 50px 50px 0 0; }\n  .thermometer .thermometer__bg-color {\n    position: absolute;\n    top: initial;\n    right: initial;\n    bottom: 0;\n    left: initial;\n    width: 100%;\n    background: linear-gradient(#ff0000, #0000ff); }\n  .thermometer .thermometer__percent-current {\n    position: absolute;\n    top: 4px;\n    right: initial;\n    bottom: initial;\n    left: 0;\n    transform: translateX(calc(-100% - 8px)) translateY(-50%);\n    padding: 5px 10px;\n    border-radius: 2px;\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 3px 3px 6px rgba(0, 0, 0, 0.1); }\n    .thermometer .thermometer__percent-current:before, .thermometer .thermometer__percent-current:after {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: initial;\n      width: 0;\n      height: 0; }\n    .thermometer .thermometer__percent-current:after {\n      border-top: 6px solid transparent;\n      border-bottom: 6px solid transparent;\n      transform: translateX(calc(100% - 2px)) translateY(0); }\n    .thermometer .thermometer__percent-current:before {\n      border-left: 8px solid rgba(0, 0, 0, 0.1);\n      border-top: 6px solid transparent;\n      border-bottom: 6px solid transparent;\n      transform: translateX(calc(100% - 0px)) translateY(0); }\n  .thermometer .thermometer__draw-a {\n    position: relative;\n    height: calc(100% - 20px);\n    margin: auto;\n    border-radius: 50px 50px 0 0;\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 1px 1px 5px rgba(0, 0, 0, 0.2); }\n    .thermometer .thermometer__draw-a:after, .thermometer .thermometer__draw-a:before {\n      content: ""; }\n    .thermometer .thermometer__draw-a:before {\n      position: absolute;\n      top: initial;\n      right: initial;\n      bottom: 0;\n      left: 0;\n      height: 50px;\n      width: 100%;\n      z-index: 1; }\n    .thermometer .thermometer__draw-a:after {\n      border-radius: 50%;\n      box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 1px 1px 5px rgba(0, 0, 0, 0.2); }\n  .thermometer .thermometer__draw-b {\n    position: absolute;\n    top: initial;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 50px;\n    height: 50px;\n    margin: auto;\n    z-index: 1; }\n    .thermometer .thermometer__draw-b:after {\n      background-color: #0000ff;\n      border-radius: 50%; }\n    .thermometer .thermometer__draw-b:before {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 40px;\n      left: 0;\n      height: 20px;\n      background-color: #0000ff;\n      border-radius: 50px 50px 0 0; }\n', ""]);
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    var t = [];
    return t.toString = function () {
      return this.map(function (t) {
        var r = function (e, t) {
          var r = e[1] || "",
              n = e[3];
          if (!n) return r;

          if (t && "function" == typeof btoa) {
            var o = (i = n, m = btoa(unescape(encodeURIComponent(JSON.stringify(i)))), l = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(m), "/*# ".concat(l, " */")),
                a = n.sources.map(function (e) {
              return "/*# sourceURL=".concat(n.sourceRoot).concat(e, " */");
            });
            return [r].concat(a).concat([o]).join("\n");
          }

          var i, m, l;
          return [r].join("\n");
        }(t, e);

        return t[2] ? "@media ".concat(t[2], "{").concat(r, "}") : r;
      }).join("");
    }, t.i = function (e, r) {
      "string" == typeof e && (e = [[null, e, ""]]);

      for (var n = {}, o = 0; o < this.length; o++) {
        var a = this[o][0];
        null != a && (n[a] = !0);
      }

      for (var i = 0; i < e.length; i++) {
        var m = e[i];
        null != m[0] && n[m[0]] || (r && !m[2] ? m[2] = r : r && (m[2] = "(".concat(m[2], ") and (").concat(r, ")")), t.push(m));
      }
    }, t;
  };
}, function (e, t, r) {
  var n,
      o,
      a = {},
      i = (n = function n() {
    return window && document && document.all && !window.atob;
  }, function () {
    return void 0 === o && (o = n.apply(this, arguments)), o;
  }),
      m = function (e) {
    var t = {};
    return function (e, r) {
      if ("function" == typeof e) return e();

      if (void 0 === t[e]) {
        var n = function (e, t) {
          return t ? t.querySelector(e) : document.querySelector(e);
        }.call(this, e, r);

        if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
          n = n.contentDocument.head;
        } catch (e) {
          n = null;
        }
        t[e] = n;
      }

      return t[e];
    };
  }(),
      l = null,
      u = 0,
      s = [],
      c = r(11);

  function f(e, t) {
    for (var r = 0; r < e.length; r++) {
      var n = e[r],
          o = a[n.id];

      if (o) {
        o.refs++;

        for (var i = 0; i < o.parts.length; i++) {
          o.parts[i](n.parts[i]);
        }

        for (; i < n.parts.length; i++) {
          o.parts.push(g(n.parts[i], t));
        }
      } else {
        var m = [];

        for (i = 0; i < n.parts.length; i++) {
          m.push(g(n.parts[i], t));
        }

        a[n.id] = {
          id: n.id,
          refs: 1,
          parts: m
        };
      }
    }
  }

  function h(e, t) {
    for (var r = [], n = {}, o = 0; o < e.length; o++) {
      var a = e[o],
          i = t.base ? a[0] + t.base : a[0],
          m = {
        css: a[1],
        media: a[2],
        sourceMap: a[3]
      };
      n[i] ? n[i].parts.push(m) : r.push(n[i] = {
        id: i,
        parts: [m]
      });
    }

    return r;
  }

  function p(e, t) {
    var r = m(e.insertInto);
    if (!r) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
    var n = s[s.length - 1];
    if ("top" === e.insertAt) n ? n.nextSibling ? r.insertBefore(t, n.nextSibling) : r.appendChild(t) : r.insertBefore(t, r.firstChild), s.push(t);else if ("bottom" === e.insertAt) r.appendChild(t);else {
      if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
      var o = m(e.insertAt.before, r);
      r.insertBefore(t, o);
    }
  }

  function d(e) {
    if (null === e.parentNode) return !1;
    e.parentNode.removeChild(e);
    var t = s.indexOf(e);
    t >= 0 && s.splice(t, 1);
  }

  function _(e) {
    var t = document.createElement("style");

    if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
      var n = function () {
        0;
        return r.nc;
      }();

      n && (e.attrs.nonce = n);
    }

    return b(t, e.attrs), p(e, t), t;
  }

  function b(e, t) {
    Object.keys(t).forEach(function (r) {
      e.setAttribute(r, t[r]);
    });
  }

  function g(e, t) {
    var r, n, o, a;

    if (t.transform && e.css) {
      if (!(a = "function" == typeof t.transform ? t.transform(e.css) : t.transform.default(e.css))) return function () {};
      e.css = a;
    }

    if (t.singleton) {
      var i = u++;
      r = l || (l = _(t)), n = x.bind(null, r, i, !1), o = x.bind(null, r, i, !0);
    } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (r = function (e) {
      var t = document.createElement("link");
      return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", b(t, e.attrs), p(e, t), t;
    }(t), n = function (e, t, r) {
      var n = r.css,
          o = r.sourceMap,
          a = void 0 === t.convertToAbsoluteUrls && o;
      (t.convertToAbsoluteUrls || a) && (n = c(n));
      o && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
      var i = new Blob([n], {
        type: "text/css"
      }),
          m = e.href;
      e.href = URL.createObjectURL(i), m && URL.revokeObjectURL(m);
    }.bind(null, r, t), o = function o() {
      d(r), r.href && URL.revokeObjectURL(r.href);
    }) : (r = _(t), n = function (e, t) {
      var r = t.css,
          n = t.media;
      n && e.setAttribute("media", n);
      if (e.styleSheet) e.styleSheet.cssText = r;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(r));
      }
    }.bind(null, r), o = function o() {
      d(r);
    });

    return n(e), function (t) {
      if (t) {
        if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
        n(e = t);
      } else o();
    };
  }

  e.exports = function (e, t) {
    if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
    (t = t || {}).attrs = "object" == typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" == typeof t.singleton || (t.singleton = i()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
    var r = h(e, t);
    return f(r, t), function (e) {
      for (var n = [], o = 0; o < r.length; o++) {
        var i = r[o];
        (m = a[i.id]).refs--, n.push(m);
      }

      e && f(h(e, t), t);

      for (o = 0; o < n.length; o++) {
        var m;

        if (0 === (m = n[o]).refs) {
          for (var l = 0; l < m.parts.length; l++) {
            m.parts[l]();
          }

          delete a[m.id];
        }
      }
    };
  };

  var y,
      v = (y = [], function (e, t) {
    return y[e] = t, y.filter(Boolean).join("\n");
  });

  function x(e, t, r, n) {
    var o = r ? "" : n.css;
    if (e.styleSheet) e.styleSheet.cssText = v(t, o);else {
      var a = document.createTextNode(o),
          i = e.childNodes;
      i[t] && e.removeChild(i[t]), i.length ? e.insertBefore(a, i[t]) : e.appendChild(a);
    }
  }
}, function (e, t) {
  e.exports = function (e) {
    var t = "undefined" != typeof window && window.location;
    if (!t) throw new Error("fixUrls requires window.location");
    if (!e || "string" != typeof e) return e;
    var r = t.protocol + "//" + t.host,
        n = r + t.pathname.replace(/\/[^\/]*$/, "/");
    return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
      var o,
          a = t.trim().replace(/^"(.*)"$/, function (e, t) {
        return t;
      }).replace(/^'(.*)'$/, function (e, t) {
        return t;
      });
      return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a) ? e : (o = 0 === a.indexOf("//") ? a : 0 === a.indexOf("/") ? r + a : n + a.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
    });
  };
}]);